import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE, setToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { completeGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        // Le backend externe échange le session_id contre un session_token.
        const { data } = await axios.post(`${API_BASE}/auth/session`, { session_id: sessionId });
        if (data?.session_token) setToken(data.session_token);
        completeGoogle(data?.session_token, data?.user);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError("Échec de la connexion Google. Réessayez.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [location.hash, navigate, completeGoogle]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0f172a] text-white gap-4">
      <div className="h-10 w-10 rounded-full border-2 border-brass border-t-transparent animate-spin" />
      <p className="font-serif text-2xl">{error || "Connexion en cours…"}</p>
    </div>
  );
}
